<template>
  <v-container fluid>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout row wrap v-else>
      <v-flex xs12>
        <v-toolbar color="#eee" class="elevation-0 secondary--text">
          <v-toolbar-title>Versionamento</v-toolbar-title>

          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" :fullscreen="$vuetify.breakpoint.xs" lazy hide-overlay transition="dialog-bottom-transition" width="600">
            <v-btn icon color='info' slot="activator">
              <v-icon>add</v-icon>
            </v-btn>
            <cadastrar-versao v-on:fechar="dialog = false" v-on:info="showInfo" v-on:error="showError"></cadastrar-versao>
          </v-dialog>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="headersVersao"
          :items="versoes"
          :expand="expand"
          :totalItems="totalItems"
          :pagination.sync="pagination"
          :loading="loading"
          hide-actions
          item-key="id_versao"
        >
          <template v-slot:items="props">
            <tr @click="props.expanded = !props.expanded">
              <td class="text-xs-left">
                {{props.item.versao}}
              </td>
              <td class="text-xs-left" v-if="props.item.data_versao">
                {{props.item.data_versao.split('-').reverse().join('-')}}
              </td>
              <td class="text-xs-left">
                <v-icon color="teal" v-if="props.item.app_cliente" size="30">check_circle</v-icon>
                <v-icon color="grey lighten-1" v-else size="30">cancel</v-icon>
              </td>
              <td class="text-xs-left">
                <v-icon color="teal" v-if="props.item.app_posto" size="30">check_circle</v-icon>
                <v-icon color="grey lighten-1" v-else size="30">cancel</v-icon>
              </td>
              <td class="text-xs-right">
                <v-tooltip bottom lazy>
                  <template v-slot:activator="{ on }">
                    <v-btn icon flat color="info" v-on="on" @click="editarVersao(props.item)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom lazy>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" flat color="red" @click="excluirVersao(props.item)">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </template>
                  <span>Apagar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:expand="props">
            <v-card flat>
              <v-card-text v-html="props.item.descricao"></v-card-text>
            </v-card>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination color="info" circle v-model="pagination.page" :length="pages"></v-pagination>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog lazy :fullscreen="$vuetify.breakpoint.xs" v-model="dialogEditarVersao" width="600">
      <editar-versao v-on:fechar="dialogEditarVersao = false" v-on:info="showInfo" v-on:error="showError"></editar-versao>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.active = false"
      >
        Fechar
      </v-btn>
  </v-snackbar>
  </v-container>
</template>

<script>

import CadastrarVersao from '@/components/cadastros/CadVersao'
import SmartLockMessage from '@/components/SmartLockMessage'
import EditarVersao from '@/components/dialogs/DialogEditarVersao'

export default {
  components: { CadastrarVersao, EditarVersao, SmartLockMessage },
  data () {
    return {
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      totalItems: 0,
      expand: false,
      pagination: {
        rowsPerPage: 5
      },
      dialog: false,
      dialogEditarVersao: false,
      headersVersao: [
        {
          text: 'Versão',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Data da Versão',
          sortable: false,
          align: 'left'
        },
        {
          text: 'App Cliente',
          sortable: false
        },
        {
          text: 'App Posto',
          sortable: false,
          align: 'left'
        },
        {
          sortable: false,
          align: 'right'
        }
      ]
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItems == null
      ) return 0

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    },
    smartLock () {
      return this.$store.getters.smartLock
    },
    versoes () {
      return this.$store.getters.versoes
    },
    loading () {
      return this.$store.getters.loading
    },
    headers () {
      return this.$store.getters.headers
    }
  },
  watch: {
    pagination: {
      handler () {
        this.carregarVersoes()
      },
      deep: true
    },
    headers (val) {
      if (val !== null && val !== undefined) {
        this.carregarVersoes()
      }
    }
  },
  mounted () {
    if (this.headers) {
      this.carregarVersoes()
    }
  },
  methods: {
    carregarVersoes () {
      this.$store.dispatch('carregarVersoes', this.pagination).then(json => {
        this.totalItems = json.count
      })
    },
    editarVersao (versao) {
      this.$store.dispatch('selectVersao', versao)
      this.dialogEditarVersao = true
    },
    excluirVersao (versao) {
      this.$store.dispatch('excluirVersao', versao).then(response => {
        this.showInfo('Versão apagada com sucesso')
        this.carregarVersoes()
      }).catch(() => {
        this.showError('Não foi possível apagar a versão')
      })
    },
    showInfo (info) {
      this.snackbar.color = 'info'
      this.snackbar.text = info
      this.snackbar.active = true
      this.$store.dispatch('carregarVersoes', this.pagination)
    },
    showError (error) {
      this.snackbar.color = 'error'
      this.snackbar.text = error
      this.snackbar.active = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
